import { styled as s } from "@mui/material";
import { css as t } from "styled-components";
const r = t, e = s;
export {
  r as css,
  e as styled
};
//# sourceMappingURL=styled2.mjs.map
